import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {Link} from 'react-router-dom';
import React,{Component} from 'react';
import firebase from 'firebase';
import store from '../../store';

const database=firebase.database();

const styles={marginTop:'40px'}

class GananciaSocio extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			socios:[],
			viajes:[],
			empleados:[],
			ganancias:[],
			gananciastemp:[],
			fecha_actual:'',
			fecha_minima:'',
			input_disabled:'disabled',
			labels:['Socio','Total $'],
			gananciastemp:[]
		
		}


		this.handleInputDate1Changed=this.handleInputDate1Changed.bind(this);
		this.handleInputDate2Changed=this.handleInputDate2Changed.bind(this);
		this.changeStatePrint=this.changeStatePrint.bind(this);
		
		this.sociosRef=database.ref().child('Socios');
		this.empleadosRef=database.ref().child('Empleados');
		this.viajesRef=database.ref().child('Viaje');

		this.handleClickPrint=this.handleClickPrint.bind(this);
		this.handleOnClickRegistrosGenerales=this.handleOnClickRegistrosGenerales.bind(this);
		
		this.setState({ganancias:[]})
			
		let f=new Date();
		
		this.state.fecha_actual=f.getFullYear()+'-'+((f.getMonth()+1)>10 ? f.getMonth:'0'+(f.getMonth()+1))+'-'+(f.getDate()>10?f.getDate():'0'+f.getDate());
		
	}
	
	componentDidMount(){
		this.setState({ganancias:[]})
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);
	
	}	
		
	gotDataSocios=(data)=>{
		
		let newSocios=[];
		
		
		
		if(data.val()!==null){
		
		
			
			let datasocios=data.val();
			
			let keys=Object.keys(datasocios);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
					
					
				
				newSocios.push({
					key:k,
					nombre:datasocios[k].Nombre,
					apellido:datasocios[k].Apellido,
					estado:datasocios[k].Estado

				})
				
			}
			this.state.socios=newSocios;
			this.setState({socios:newSocios});
			this.empleadosRef.once('value',this.gotDataEmpleados,this.errDataEmpleados);
		}
		
		
	}
	errDataSocios=(err)=>{
		
		console.log(err);
	}
	
	
	gotDataEmpleados=(data)=>{
		
		let newEmpleado=[];
		
		
		if(data.val()!==null ){
			
		
			
			
			let dataempleados=data.val();
			
			let keys=Object.keys(dataempleados);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				
				let socio=this.state.socios.find(socios=>socios.key===dataempleados[k].socio);
				
				let nombre_socio=(socio!==undefined)?socio.nombre+' '+socio.apellido:' ';
				
			
				newEmpleado.push({
					
					key:k,
					socio:nombre_socio
					
				})
				
			}
			this.state.empleados=newEmpleado;
			this.setState({empleados:newEmpleado});
			
			this.viajesRef.once('value',this.gotDataViajes,this.errDataViajes);
		}

	}
	errDataEmpleados=(err)=>{
		
		console.log(err)
		
	}
	
	gotDataViajes=(data)=>{
		
		let newViajes=[];
		
		if(data.val()!==null ){
			
			
			
			let dataviajes=data.val();
			
			let keys=Object.keys(dataviajes);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
			

				let empleado_socio=this.state.empleados.find(empleados=>empleados.key===dataviajes[k].empleado);
				
				if(empleado_socio!==undefined){
					
					
					let ex_ganancias=this.state.ganancias.find(ganancias=>ganancias.socio===empleado_socio.socio);
					let fecha;
					try{
						fecha = (dataviajes[k].fechaBajada!==undefined)?dataviajes[k].fechaBajada.substring(0,10):""
					}
					catch(error){
						let fecha2 = (dataviajes[k].fechaBajada!==undefined)?new Date(dataviajes[k].fechaBajada):"";
						fecha = fecha2.getDate() + (fecha2.getMonth()+1) + fecha2.getFullYear();
					}
					newViajes.push({
						key:k,
						socio:empleado_socio.socio,
						fecha:fecha,
						pago:dataviajes[k].pago,
						total:dataviajes[k].total						
					})
					
					
					let pos =this.state.ganancias.indexOf(ex_ganancias);
					
					
					
					if(pos===-1){

						if(dataviajes[k].total !== undefined)
						{
						
						this.state.ganancias.push({
							
							socio:empleado_socio.socio,
							total:parseFloat(dataviajes[k].total)
							
						})
						}
					}
					else{
						if(dataviajes[k].total !== undefined)
						{
							this.state.ganancias[pos].total+=(parseFloat(dataviajes[k].total)) ;
						}
					}
					
			}
				
			}
			
			this.setState({
				viajes:newViajes,
				ganancias:this.state.ganancias,
				gananciastemp:this.state.ganancias
			
			});
			
			
			
		}
		
		
	}
	errDataViajes=(err)=>{
		
		console.log(err);
		
	}
	
	
	handleInputDate1Changed(){
		
		this.setState({
			fecha_minima:this.fecha1.value,
			input_disabled:''
		})
		
		if(this.fecha2.value!==""){
			
			this.fecha2.value="";
		}
		
	}
	
	handleInputDate2Changed(){

	
		
	
		let inputDateInicio=this.fecha1.value;
		let inputDateFin=this.fecha2.value;
		
		let f1=new Date(inputDateInicio);
		let f2=new Date(inputDateFin);
		
		
		let newArray=[]
		
		
		
		for(let i=0;i<this.state.ganancias.length;i++){
			
			
			this.state.ganancias[i].total=0;
			
		}
		
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			
			let fecha_registro=new Date(this.state.viajes[i].fecha);
		
			
			
			
			if(fecha_registro.getTime()>=f1.getTime() && fecha_registro.getTime()<=f2.getTime()){
				
				
				for(let j=0;j<this.state.ganancias.length;j++){
					
					if(this.state.ganancias[j].socio===this.state.viajes[i].socio){
						
						
						this.state.ganancias[j].total+=parseFloat(this.state.viajes[i].total);
						
						
					}
					
					
					
				}
				
				
				
				
			}
			
			
			
			
		}
		this.state.ganancias=this.state.ganancias;
		this.setState({
			ganancias:this.state.ganancias
		})

		
	}
	
	
	handleOnClickRegistrosGenerales(){
	
	
		this.fecha1.value="";
		this.fecha2.value="";
		this.state.ganancias=this.state.gananciastemp
		this.setState({
			input_disabled:'disabled',
			fecha_minima:'',
			ganancias:this.state.gananciastemp
	
		})
		
		
	}
	
	
	
		
		
	changeStatePrint(){
	
		store.dispatch({			
			type: "STATE_REPORT",
			labels_report:this.state.labels,
			data_report:this.state.ganancias,
			tipo_reporte:'ganancia_socio'
		})
	
	
	}
		
		
	handleClickPrint(){
		
		this.changeStatePrint();
		
	}

	onKeyUpFilter = () =>{
		if(this.state.gananciastemp===[]){
			this.setState({gananciastemp:this.state.ganancias})
		}
		let newSearch=[];
		let socio=this.socio.value;
		if(socio!=='')
		{
			for(let i=0;i<this.state.ganancias.length;i++){
				let socio_filter=this.state.ganancias[i].socio.toLowerCase().search(socio.toLowerCase())>=0?true:false;				
					if(socio_filter){
						
						newSearch.push({
							
							key:this.state.ganancias[i].key,
							socio:this.state.ganancias[i].socio,
							total:this.state.ganancias[i].total
							
						})
						
						
						
					}
			}
			this.setState({
				
				ganancias:newSearch
			})
		}
		else{
			this.setState({
				
				ganancias:this.state.gananciastemp
			})
		}
		
	}
	
	
	render(){
		
		return(
		
			<div className="ganancia_socio">
				
				<center><h3>Ganancias Socio</h3></center>
				
				<div className="row" style={styles}>
					
						<div className="col-md-3">
							<br/>
							<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span class="glyphicon glyphicon-print"> Imprimir</span></Link>
						</div>
						
						<div className="col-md-3">
							<div className="form-group">
								<label>Fecha Inicio</label>
								<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleInputDate1Changed}
									ref={input=>{this.fecha1=input;}}							
								/>
							</div>
						</div>
						
						<div className="col-md-3">
							<div className="form-group">
								<label>Fecha Final</label>
								<input type="date" className="form-control" max={this.state.fecha_actual} min={this.state.fecha_minima} disabled={this.state.input_disabled}
									ref={input=>{this.fecha2=input;}} onChange={this.handleInputDate2Changed}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="socio">Socio</label>
								<input type="text" name="socio"  placeholder="Socio" className="form-control"
									ref={input=>{this.socio=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>						
						</div>
						
						<div className="col-md-3">
							<div className="form-group">
								<label></label><br/>
								<button type="button" className="btn btn-primary" onClick={this.handleOnClickRegistrosGenerales}>Reestablecer fechas</button>
							</div>
						</div>
					
					
					</div>
					
				
	
				
				<BootstrapTable data={ this.state.ganancias }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='socio'  dataSort={true}  >Socio</TableHeaderColumn>							
							 <TableHeaderColumn dataField='total'  dataSort={true} dataAlign='center'>Ganancias</TableHeaderColumn>							
							 
							 
			   </BootstrapTable>	
				
				
			</div>
		
		);
		
	}
	
}

export default GananciaSocio;


// WEBPACK FOOTER //
// ./src/Components/Reportes/GanaciaSocio.jsx